// The home menu's Constellations entry: every constellation the player has
// written tonight, on all levels, as the play menu's cards; empty at the
// start of each night, when it says where to find them. Always tonight's,
// also from an archive night's home. The Worker answers with the Horoscope's
// list (hard-tagged words left out, as for its signs).
import { useEffect, useState } from 'react';
import { api } from '../../systems/api/client';
import type { HoroscopeResponse } from '../../systems/api/types';
import { ConstellationCard } from '../play/completion/ConstellationCards';
import { WEEKDAY_SKIES } from '../sky/weekdaySkies';
import '../play/completion/completion.css';

/** The night's constellations, read again each time the menu opens so a play just finished shows. */
export function useTonightConstellations(open: boolean): { data: HoroscopeResponse | null; failed: boolean } {
  const [state, setState] = useState<{ data: HoroscopeResponse | null; failed: boolean }>({ data: null, failed: false });
  useEffect(() => {
    if (!open) return;
    let current = true;
    api
      .horoscope(null)
      .then((data) => current && setState({ data, failed: false }))
      .catch(() => current && setState((s) => ({ ...s, failed: true })));
    return () => {
      current = false;
    };
  }, [open]);
  return state;
}

export function TonightConstellations({ data, failed }: { data: HoroscopeResponse | null; failed: boolean }) {
  if (!data) return <p>{failed ? 'The sky is out of reach. Check your connection.' : "Reading tonight's sky…"}</p>;
  if (data.constellations.length === 0) return <p>Play today's puzzles to discover constellations.</p>;
  const sky = WEEKDAY_SKIES[data.weekday];
  return (
    <ul className="constellation-cards">
      {data.constellations.map((c) => (
        <ConstellationCard key={c.id} figure={c} stars={c.stars} sky={sky} />
      ))}
    </ul>
  );
}
